/* Campaña verano 2026 COREX.
   - Auto-add del regalo (día 27 / phase2): añade la variante muñequeras negras si no está.
   - Respeta la eliminación manual: si el cliente la quita, no se re-añade (sessionStorage).
   - Tras el add, refresca el side-cart con el MECANISMO PROPIO de Xclusive:
     fetch('?section_id=side-cart') -> reemplaza #cart -> evento 'listCart' (re-bind del tema) + #cart-count.
   El gating de fecha lo decide window.COREX_CAMPAIGN (server-side), no el reloj del cliente. */
console.log('[corex-summer] v3 (fetch-intercept)');
(function () {
  var C = window.COREX_CAMPAIGN;
  if (!C || !C.phase2) return;

  var VID = C.giftVariantId;
  var K_REMOVED = 'corex_gift_removed';
  var K_PRESENT = 'corex_gift_present';
  var ensuring = false;

  function hasGift(cart) {
    return (cart.items || []).some(function (i) { return i.variant_id === VID; });
  }

  // Refresco del drawer usando las piezas propias del tema Xclusive (custom-async.js):
  // sección 'side-cart', contenedor '#cart', evento 'listCart' (re-vincula remove/qty).
  function refreshThemeDrawer() {
    // Preferir el pipeline COMPLETO del tema: updateCartPanel (expuesto como ajaxCart.load).
    // forceRefetch=true, openCartPanel=false -> fetch side-cart + handleCartPanel
    // (eventos + handleCartUpdates + updateCartCount), sin auto-abrir el drawer.
    try {
      if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
        window.ajaxCart.load(false, false, false, true);
        return Promise.resolve();
      }
    } catch (e) { /* si falla, cae al fallback manual */ }

    // Fallback: ajaxCart aún no cargado -> refresco manual mínimo (innerHTML + listCart + count).
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + '?section_id=side-cart', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#shopify-section-side-cart');
        var container = document.getElementById('cart');
        if (fresh && container) {
          container.innerHTML = fresh.innerHTML;
          window.dispatchEvent(new CustomEvent('listCart'));
          var qtyEl = fresh.querySelector('[data-totalqty]');
          var countEl = document.getElementById('cart-count');
          if (qtyEl && countEl) countEl.textContent = qtyEl.dataset.totalqty;
        }
      })
      .catch(function () {});
  }

  function ensureGift() {
    if (ensuring) return; // anti-reentrada: refreshThemeDrawer dispara 'listCart'
    ensuring = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var present = hasGift(cart);

        // Detección de eliminación manual: estaba presente y ahora no -> el cliente lo quitó.
        if (!present && sessionStorage.getItem(K_PRESENT) === '1') {
          sessionStorage.setItem(K_REMOVED, '1');
        }
        if (present) { sessionStorage.setItem(K_PRESENT, '1'); return; }

        // No re-añadir si el cliente ya lo quitó a propósito.
        if (sessionStorage.getItem(K_REMOVED) === '1') return;

        // Carrito vacío: no forzamos el regalo sobre un carrito sin nada.
        if (!cart.items || cart.items.length === 0) return;

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: VID, quantity: 1 }] })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            sessionStorage.setItem(K_PRESENT, '1');
            return refreshThemeDrawer(); // refresco silencioso (no abre el drawer)
          });
      })
      .catch(function () { /* silencioso */ })
      .then(function () { ensuring = false; }); // liberar SIEMPRE (éxito o error)
  }

  // Detecta si un body de /cart/add.js es NUESTRO propio add del regalo (para no re-interceptarlo).
  // Cubre JSON string, FormData y URLSearchParams (por si algún flujo del tema no usa JSON).
  function bodyHasGift(body) {
    try {
      if (typeof body === 'string') return body.indexOf(String(VID)) !== -1;
      if (body && typeof body.get === 'function') { // FormData / URLSearchParams
        var id = body.get('id');
        return id != null && String(id) === String(VID);
      }
    } catch (e) {}
    return false;
  }

  ensureGift(); // 1) al cargar la página (cubre flujos que redirigen a /cart, p.ej. personalización)

  // 2) Disparador ROBUSTO por cambios del carrito, INDEPENDIENTE de window.fetch.
  //    Motivo: Shopify Web Pixels Manager reenvuelve window.fetch de forma asíncrona
  //    DESPUÉS de este <script defer>, pisando cualquier intercept de fetch (carrera de
  //    orden de carga). Por eso NO nos apoyamos en envolver fetch. En su lugar observamos
  //    el badge #cart-count (el tema lo actualiza en TODOS los flujos de add: nativo,
  //    personalización, cross-sell, variant-modal, sticky) y el evento propio 'listCart'.
  //    ensureGift() ya es idempotente (anti-reentrada + hasGift + respeta K_REMOVED).
  var countEl = document.getElementById('cart-count');
  if (countEl && 'MutationObserver' in window) {
    var lastCount = countEl.textContent;
    new MutationObserver(function () {
      if (countEl.textContent !== lastCount) {
        lastCount = countEl.textContent;
        setTimeout(ensureGift, 0);
      }
    }).observe(countEl, { childList: true, characterData: true, subtree: true });
  }
  // Evento propio del tema Xclusive tras refrescar el panel de carrito.
  window.addEventListener('listCart', function () { setTimeout(ensureGift, 0); });

  // 3) Bonus: intercept de /cart/add.js SI ganamos la carrera de fetch (cuando el web-pixel
  //    aún no ha reenvuelto). No es la vía principal; el observer de arriba es el respaldo real.
  //    BLINDADO: cualquier error dentro del intercept NO puede romper el add-to-cart.
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      var shouldEnsure = false;
      try {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        if (/\/cart\/add(\.js)?/.test(url) && !bodyHasGift(init && init.body)) {
          shouldEnsure = true;
        }
      } catch (e) { shouldEnsure = false; } // si el intercept peta -> tienda funciona como sin patch
      var p = origFetch.apply(this, arguments); // llamada ÚNICA e incondicional
      if (shouldEnsure) {
        try { p.then(function () { setTimeout(ensureGift, 0); }).catch(function () {}); } catch (e) {}
      }
      return p;
    };
  }
})();
